
import { defineComponent } from 'vue'
export default defineComponent({
  emits: [],
  components: {},
  name: 'InvoiceRule',
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {
    return {}
  }
})
